import React from 'react';
import './withUniResizableColumn.css';
import { getInnerWidth } from '../util/ScreenUtil';
const withUniResizableColumn = (Component) => {
  type Props = {
    widthOfCol: number,
    setColWidth: function,
    getMinWidth: number,
    getMaxWidth: number,
    doUpdateWithScreenResize: object,
    hideSeperator: ?boolean
  };
  type State = {
    widthOfColumn: number,
    withinResizingArea: boolean,
    resize: boolean,
    resizeLinePosition: object,
    initialResizeLinePosition: number,
    lastResizingLinePosition: number
  };
  return class withUniResizableColumn extends React.Component<Props, State> {
    constructor(props) {
      super(props);
      this.innerWidth = getInnerWidth();
      this.state = {
        widthOfColumn: props.widthOfCol,
        withinResizingArea: false,
        resize: false,
        resizeLinePosition: {},
        initialResizeLinePosition: 0,
        lastResizingLinePosition: 0
      };
    }

    componentDidMount() {  
      const {isUpdateWithScreenResize} = this.props;   
      document.addEventListener('mouseup', this.onMouseUpForDoneResize);
      document.addEventListener('mousemove', this.onMouseMoveForResize);
      if(isUpdateWithScreenResize) window.addEventListener('resize', this.onWindowResize)
    }

    componentWillUnmount() {
      const {isUpdateWithScreenResize} = this.props;   
      document.removeEventListener('mouseup', this.onMouseUpForDoneResize);
      document.removeEventListener('mousemove', this.onMouseMoveForResize);
      if(isUpdateWithScreenResize) window.removeEventListener('resize', this.onWindowResize)
    }

    onWindowResize = _.throttle(() => {
      const changeInColumnWidth = window.innerWidth - this.innerWidth;
      this.innerWidth = getInnerWidth();
      this.updateColumnWidth(changeInColumnWidth, true);
    }, 100)

    setClassNameOfCol = (classNameOfCol) => {
      this.setState({ classNameOfCol });
    };

    setInitialResizeLinePosition = (initialResizeLinePosition) => {
      this.setState({ initialResizeLinePosition });
    };

    setLastResizingLinePosition = (lastResizingLinePosition) => {
      this.setState({ lastResizingLinePosition });
    };

    setWithinResizingArea = (withinResizingArea) => {
      this.setState({ withinResizingArea });
    };

    setResize = (resize) => {
      this.setState({ resize });
    };

    setResizeLinePosition = (resizeLinePosition) => {
      this.setState({ resizeLinePosition });
    };

    onMouseMoveForResize = (e: MouseEvent) => {
      const { resize } = this.state;
      const { getMinWidth, getMaxWidth } = this.props;
      if (resize && e.clientX <= getMaxWidth() && e.clientX >= getMinWidth()) {
        this.setResizeLinePosition({ left: e.clientX });
      }
    };

    onMouseEnterForResize = (e: MouseEvent) => {
      document.body.style.cursor = 'col-resize';
      this.setWithinResizingArea(true);
    };

    onMouseLeaveForResize = (e: MouseEvent) => {
      const { resize } = this.state;
      if (!resize) {
        this.setWithinResizingArea(false);
        document.body.style.cursor = 'default';
      }
    };

    onMouseDownForResize = (e: MouseEvent) => {
      const { withinResizingArea } = this.state;
      if (withinResizingArea) {
        this.setResize(true);
        this.setResizeLinePosition({ left: e.clientX });
        this.setInitialResizeLinePosition(e.clientX);
      }
    };

    onMouseUpForDoneResize = (e: MouseEvent) => {
      const { resize, initialResizeLinePosition } = this.state;
      if (resize) {
        const lastResizingLinePosition = e.clientX;
        const changeInColumnWidth = lastResizingLinePosition - initialResizeLinePosition;
        this.setResize(false);
        this.setLastResizingLinePosition(lastResizingLinePosition);
        this.updateColumnWidth(changeInColumnWidth, false);
      }
      document.body.style.cursor = 'default';
    };

    nullifyDragEvent = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };

    updateColumnWidth = (changeInColumnWidth: number, triggerByWindowResize: boolean = false) => {
      const { widthOfCol, setColWidth, getMinWidth, getMaxWidth } = this.props;
      const newWidth = Math.abs(changeInColumnWidth + widthOfCol);
      const minWidth = getMinWidth();
      const maxWidth = getMaxWidth();
      if (triggerByWindowResize) {
        if (newWidth < minWidth) setColWidth(minWidth, true);
        else if (newWidth > maxWidth) setColWidth(maxWidth, true);
        else setColWidth(newWidth, true);
      } else {
        if (newWidth < minWidth) setColWidth(minWidth, true);
        else if (newWidth > maxWidth) setColWidth(maxWidth, true);
        else setColWidth(newWidth, true);
      }

    };

    onRef = (ref) => {
      this._component = ref;
    };

    render() {
      const { resize, resizeLinePosition } = this.state;
      const { hideSeperator=false } = this.props;
      return hideSeperator ?  <Component ref={this.onRef} {...this.props}></Component> : (
        <div name="withUniResizableColumn" className="uni-resize-col-container flex-row">
          <Component ref={this.onRef} {...this.props}></Component>
          <div
            className="uni-resizer"
            onMouseEnter={this.onMouseEnterForResize}
            onMouseLeave={this.onMouseLeaveForResize}
            onMouseDown={this.onMouseDownForResize}
            onDragStart={this.nullifyDragEvent}></div>
          {resize ? (
            <div>
              <div className="transparent-background uni-resize-bg" />
              <div className="uni-resize-seperator" style={resizeLinePosition}></div>
            </div>
          ) : null}
        </div>
      )
    }
  };
};
export default withUniResizableColumn;
